export default "__VITE_ASSET__6324c1e5__"